"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toyota_system_1 = require("./Toyota/toyota-system");
class Themes {
    constructor(brand) {
        if (brand === 'toyota')
            this.values = toyota_system_1.default;
        if (brand === 'lexus')
            this.values = toyota_system_1.default;
    }
    get theme() {
        return {
            fonts: this.palette,
            materialConfig: this.palette,
            palette: this.palette,
        };
    }
    get palette() {
        return {
            alwaysBlack: this.createRGB(this.values.balck_1),
            alwaysWhite: this.createRGB(this.values.white_1),
            gray_0: this.createRGB(this.values.gray_0),
            gray_1: this.createRGB(this.values.gray_1),
            gray_2: this.createRGB(this.values.gray_2),
            gray_3: this.createRGB(this.values.gray_3),
            gray_4: this.createRGB(this.values.gray_4),
            gray_5: this.createRGB(this.values.gray_5),
            gray_6: this.createRGB(this.values.gray_6),
            gray_7: this.createRGB(this.values.gray_7),
            gray_8: this.createRGB(this.values.gray_8),
            listHighlight: this.createRGBA(this.values.listHighlight.color, this.values.listHighlight.transparency),
            primary_1: this.createRGB(this.values.primary_1),
            primary_2: this.createRGB(this.values.primary_2),
            primary_3: this.createRGB(this.values.primary_3),
            primary_4: this.createRGB(this.values.primary_4),
            primary_5: this.createRGB(this.values.primary_5),
            red_orange_180: '',
            yellow_1: this.createRGB(this.values.yellow_1),
        };
    }
    createRGBA(color, transparency) {
        return `rgba(${color}, ${transparency})`;
    }
    createRGB(value) {
        return `rgb(${value})`;
    }
}
exports.default = Themes;
//# sourceMappingURL=Themes.js.map